export const RENDER_POPUP_TIMEOUT = 30000;
export const RENDER_BUSY_POPUP_TIMEOUT = 10000;
